import { Route, Switch } from "react-router-dom";
import { DbUser } from "../../../interfaces";
import { InsightsSummaryPage } from "../../../pages/v2/InsightsSummaryPage";
import { UsersPage } from "../../../pages/v2/UsersPage";
import { ClassSettingsPage } from "../../../pages/v3/ClassSettingsPage";
import { Helmet } from "react-helmet-async";

export const InsightsRouter = ({ currentUser }: { currentUser: DbUser }) => {
  return (
    <>
      <Helmet>
        <title>Insights | Digit</title>
      </Helmet>
      <Switch>
        <Route exact path="/insights/class/:class_id/settings">
          <ClassSettingsPage currentUser={currentUser} />
        </Route>
        <Route exact path="/insights/class/:class_id/students">
          <UsersPage
            tab={0}
            title="Students"
            description="Access student information here and share student progress with other teachers."
            subHeading="Your students"
            columnNames={["first_name", "last_name", "last_access_at", "action"]}
            hideTabs={true}
            includeArchivedUsers={true}
          />
        </Route>
        <Route exact path="/insights/class/:class_id/assignments">
          <UsersPage
            tab={7}
            title="Assignments"
            description="Access synced LTI Assignment data pulled from Canvas."
            subHeading="Canvas Assignments"
            columnNames={[
              "course_name",
              "class_subject",
              "section_sln",
              "canvas_section_number",
              "resource_id",
              "grading_method",
              "grading_trigger",
              "canvas_assignment_due_date",
              "canvas_assignment_id",
              "canvas_assignment_name",
              "canvas_lp_id",
              "canvas_lp_interval",
              "canvas_term_name",
              "lti_client_id",
              "lti_tool_client_id",
              "lti_grading_method",
              "lti_grading_trigger",
              "faq_course_tag",
              "deeplink_asset_type",
              "feedback_survey_link",
            ]}
            hideTabs={true}
          />
        </Route>
        <Route exact path="/insights/class/:class_id/summary">
          <InsightsSummaryPage tab={0} />
        </Route>
        <Route exact path="/insights/class/:class_id/details">
          <InsightsSummaryPage tab={1} />
        </Route>
        <Route exact path="/insights/class/:class_id/hints-and-errors">
          <InsightsSummaryPage tab={2} />
        </Route>
        <Route exact path="/insights/class/:class_id/student/:student_id/summary">
          <InsightsSummaryPage tab={0} view="student" />
        </Route>
        <Route exact path="/insights/class/:class_id/student/:student_id/info">
          <UsersPage
            insightsView="student"
            tab={0}
            title="Student info"
            description="Access student information here."
            subHeading=""
            columnNames={["first_name", "last_name", "last_access_at", "action"]}
            hideTabs={true}
            hideSearch={true}
            hidePagination={true}
            useUsersOverride={true}
            includeArchivedUsers={true}
          />
        </Route>
      </Switch>
    </>
  );
};
